import React, { useMemo } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
import { KeyMetricsItemType, KeyMetricsType } from '../../Community/constants';
import { formatDateFunc, getFilterDateQOQText } from '@op/utils/time';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import { useIntl } from 'umi';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import { reviewsFormat } from '@op/utils/value';
import { RankKeyMeticsItem } from '../TrendCardTips';
import BubbleCommon from '@op/components/BubbleCommon';
import PRSmallChart from '../../PR/components/PRSmallChart';

export default function KeyMetricsItem({
  valueMap,
  item,
  keyMetric,
  setKeyMetric,
  filter,
  getRankList,
  showRank,
  title,
  logId,
  cardClickCallback,
  MergeChannelIconElement,
  canNavigateToGame,
  smallChart = false,
  smallChartStatistics,
}: {
  valueMap: any;
  item: KeyMetricsItemType;
  keyMetric?: KeyMetricsType;
  setKeyMetric?: (value: KeyMetricsType, text: string) => void;
  filter?: any;
  getRankList?: (key: KeyMetricsType) => { list: Array<any>; rank: number };
  showRank: boolean;
  title: string;
  logId?: string;
  cardClickCallback?: () => void;
  MergeChannelIconElement?: any;
  canNavigateToGame?: boolean;
  smallChart?: boolean;
  smallChartStatistics?: { x: never[]; y: never[] };
}) {
  const { text, key, tips, format = reviewsFormat } = item;
  const formatDate = formatDateFunc(filter.date_type);
  const { formatMessage } = useIntl();
  const [value, ratio, oldValue, newTime, oldTime] = useMemo(() => {
    const data = valueMap || {};

    const list = ['', '_ratio', '_old'].map((cur) => {
      const realKey = key + cur;
      return data[realKey] || 0;
    });

    list.push(data.newTime || [], data.oldTime || []);

    return list;
  }, [valueMap]);
  const { text: beforeText } = getFilterDateQOQText(filter);
  // 选中
  const isSelected = keyMetric === key;

  return (
    <div
      className={`dbo-community-metrics-card ${isSelected ? 'active' : ''}`}
      onClick={() => {
        setKeyMetric?.(key, text);
        cardClickCallback?.();
      }}
    >
      <BubbleCommon
        tipsMap={tips}
        showIcon={false}
        placement="top"
        extraContent={
          MergeChannelIconElement && (
            <MergeChannelIconElement metric={key}></MergeChannelIconElement>
          )
        }
      >
        <div className="dbo-community-metrics-title  --link">
          {formatMessage({ id: text })}
          <SvgIcon type="arrow-right" />
        </div>
      </BubbleCommon>
      <div className="dbo-compare">
        <div className="dbo-compare-num">
          {format(value)}
          {/* <span className="dbo-compare-num-level">Up to 5</span> */}
        </div>
        <div className="dbo-compare-flex">
          <RingRatioBubble
            newTime={newTime}
            oldTime={oldTime}
            oldValue={oldValue}
            newValue={value}
            formateDate={formatDate}
            formateValue={format}
            placement="top-start"
          >
            <div className="dbo-cardcontext-flex">
              <span className="context-text">
                {formatMessage({ id: beforeText })}
              </span>
              <PercentageItem percentage={ratio}></PercentageItem>
            </div>
          </RingRatioBubble>
        </div>
        {
          smallChart && (
            <PRSmallChart
              statistics={smallChartStatistics}
              text={formatMessage({ id: item.text })}
              dateType={filter?.date_type}
            />
          )
        }
      </div>
      <RankKeyMeticsItem
        getRankList={getRankList}
        valueKey={key}
        noShow={showRank}
        title={title}
        logId={logId}
        valueFormat={format}
        canNavigateToGame={canNavigateToGame}
      ></RankKeyMeticsItem>
    </div>
  );
}
